import { FC, ReactNode } from 'react';
import moment from 'moment-timezone';
import { SvgIcon, SvgIconProps, Typography } from '@mui/material';
import { UpdateOutlined as UpdateOutlinedIcon } from '@mui/icons-material';
import Row, { RowProps } from './Row';

interface StatusDateProps {
    date: Date;
    title?: ReactNode;
    slots?: {
        icon?: typeof SvgIcon;
    };
    slotProps?: {
        row?: RowProps;
        icon?: SvgIconProps;
    };
}

const StatusDate: FC<StatusDateProps> = ({ date, title = 'Last updated', slots = {}, slotProps = {} }) => {
    const Icon: FC<SvgIconProps> = slots?.icon ?? UpdateOutlinedIcon;

    return (
        <Row gap={0.5} sx={{ width: 'auto' }} {...slotProps?.row}>
            <Icon color="success" fontSize="small" {...slotProps?.icon} />
            <Typography variant="body2" color="text.secondary">
                {title}{' '}
                <Typography component="span" variant="body2" color="text.primary" fontWeight={500}>
                    {moment(date).format('MM/DD/YYYY [at] h:mm a')}
                </Typography>
            </Typography>
        </Row>
    );
};

export type { StatusDateProps };
export default StatusDate;
